import styled from 'styled-components';
import ShipperDetail from './component';

export default styled(ShipperDetail)`
  display: flex;

  .shipper-detail {
    width: 100%;
    &__header {
      background-color: var(--grey900);
      color: var(--white);
      font-size: 1.6rem;
      height: 48px;

      &-content {
        padding: 1rem 2rem;
        max-width: 1176px;
        margin: 0 auto;
      }
    }
    &__body {
      padding: 2rem;
      max-width: 1176px;
      margin: 0 auto;
    }
    &__container {
      background-color: var(--white);
      padding: 1rem 2rem;
      display: flex;
      line-height: 1.2rem;
    }
    &__title {
      font-size: 1.6rem;
      margin-right: 1rem;
    }
    &__subtitle {
      font-size: 1.2rem;
      margin-bottom: 8px;
      color: var(--grey700);
      text-transform: uppercase;
    }
    &__hidden-icon {
      margin-left: 2rem;
      margin-right: 1rem;
      path {
        fill: var(--grey900);
      }
    }
  }

  .sidebar-closed {
    width: 100%;
  }

  .sidebar-open {
    width: calc(100% - 115px);
  }
`;
